<template>
  <div
    id="home-tour-container"
    v-bind:class="['my-4 mx-md-5 mx-lg-10 mx-xl-10 pa-2 pt-md-0 px-md-4 maxw-1750', {
    'px-4': !$vuetify.breakpoint.mdAndUp,
    }]"
  >
    <!-- Push -->
    <!-- Carrusel -->
    <CarouselMarquee
      v-if="announcements.length > 0"
      :items="announcements"
      viewHtml="home"
    />

    <!-- Mensajes de alertas -->
    <div>
      <v-alert
        v-if="(user.emailAddress === null || user.mobilePhone === null) && !isCitizen()"
        border="bottom"
        colored-border
        type="warning"
        elevation="2"
        class="mt-2 w--100"
        light
        prominent
      >
        <v-row align="center">
          <div :style="{padding: '12px'}">
            {{$t('validation.profileForm')}} <a @click="goToProfile"> Ir a mi perfil.</a>
          </div>
        </v-row>
      </v-alert>
    </div>
    <div>
      <v-alert
        v-if="contrasenaCaduca"
        border="bottom"
        colored-border
        type="warning"
        elevation="2"
        class="mt-2 w--100"
        light
        prominent
      >
        <v-row align="center">
          <div :style="{padding: '12px'}">
              {{$t(diasParaCaducidasContrasena !== 0
                ? 'views.home.pass.notificationAlert'
                : 'views.home.pass.notificationAlertToday',
                [user.userid, diasParaCaducidasContrasena])}}

              {{diasParaCaducidasContrasena !== 0
                ? $t(diasParaCaducidasContrasena !== 1
                  ? 'views.home.pass.notificationiasDays'
                  : 'views.home.pass.notificationiasDay')
                    : null}}

              <a @click="modifPass">Modificar contraseña.</a>
            </div>
        </v-row>
      </v-alert>
    </div>

    <!-- Mensajes de bienvenida -->
    <div class="d-flex flex-column flex-no-wrap align-md-end flex-md-row" v-if="!isCitizen()">
      <h2 class="mt-4">¡Hola {{ user.middleName }}!</h2>
      <small class="mt-2 mt-md-4 ml-md-4 pb-md-1" v-if="lastAccess != null">
        {{ $t('views.home.lastAccess', { date: lastAccessDate, time: lastAccessTime}) }}
      </small>
    </div>

    <!-- Buscador general -->
    <div id="tour-home-search-general" class="container__btnSearch">
      <SearchGeneral
        ref="searchGeneral kai"
        :placeholder="$t('navbar.search')"
        :id="'search-general'"
        @search="maybeGoToSearch($event)"
      ></SearchGeneral>
    </div>

    <!-- Solicitudes -->
    <v-row class="mt-4" id="solicitudesContainer">
      <!-- Pendiente -->
      <v-col cols="12" md="6">
        <search-box
          id="solicitudesPendientesDeMi"
          class="home-request-searchbox"
          :title="$t('views.home.pendingRequests.title')"
          :totalBadge="userPendingRequests.total || 0"
          :items="userPendingRequests.data.map((item) => ([
            userPendingRequestsStatuses.find(status => status.value ===
            (item.status.relAttr || item.status.code)),
            `${item.referenceNumber} - ${item.summary}`,
          ]))"
          :loading="userPendingRequests.loading"
          :expanded="$vuetify.breakpoint.mdAndUp || flags.firstBlock"
          :isPending="true"
          @click:expand="flags.firstBlock = !flags.firstBlock"
          @click:viewMore="viewMoreByStatuses('/pending', userPendingRequests.vModel)"
          @click:item="({index}) => viewItem('/requests', userPendingRequests.data[index].id)"
        >
          <!-- Filtros -->
          <template #filters>
            <v-divider />
            <v-row
              no-gutters
              align="center"
              justify="start"
            >
              <!-- Filtros WEB -->
              <div  class="showWeb">
                <v-sheet
                  class="mb-3 mt-1 containerMyRequest"
                  :style="{ background: 'none' }"
                >
                  <div class="myRequestScroll container__chip">
                    <span
                      v-for="(filterItem, i) of userPendingRequestsStatuses"
                      :key="i"
                      :class="[filterPendings.includes(filterItem.value)
                        ? 'chip__active'
                        : '',
                      'chip__agrupaciones chip__filter v-chip']"
                    >
                    <v-badge
                      class="d-inline"
                      inline
                      :color="stateColor(filterItem.value)"
                      dot
                    ></v-badge>
                      <span @click="selectFilterPending(filterItem)">
                        {{ filterItem.text }}
                      </span>
                    </span>
                  </div>
                </v-sheet>
              </div>

              <!-- Filtros Movil -->
              <FiltersSlide
                v-if="showFilters && flags.firstBlock"
                :isBadge="isBadge"
                :filters="filterInitialPendings"
                :selectedFilters="filterPendings"
                @filter-selected="selectFilterPending"
              />
            </v-row>
          </template>

          <!-- Listado -->
          <template v-slot:item-0="data">
            <v-avatar
              :color="stateColor(data.column.value)"
              :size="24"
            >
              <span class="white--text text-caption">
                {{ data.column.initials }}
              </span>
            </v-avatar>
          </template>
        </search-box>
      </v-col>

      <!-- Mis solicitudes -->
      <v-col cols="12" md="6">
        <search-box
          id="misSolicitudes"
          class="home-request-searchbox"
          :title="$t('views.home.myRequests.title')"
          :totalBadge="myRequests.total"
          :loading="myRequests.loading"
          :items="myRequests.data.map((item) => ([
            myRequestsStatuses.find(status => status.value ===
            (item.status.relAttr || item.status.code)),
            `${item.referenceNumber} - ${item.summary}`,
          ]))"
          :expanded="$vuetify.breakpoint.mdAndUp || flags.secondBlock"
          :isPending="false"
          @click:expand="flags.secondBlock = !flags.secondBlock"
          @click:viewMore="viewMoreByStatuses('/requests', myRequests.vModel)"
          @click:item="({index}) => viewItem('/requests', myRequests.data[index].id)"
        >
          <!-- Filtros -->
          <template #filters>
            <v-divider />
            <v-row
              no-gutters
              align="center"
              justify="start"
            >
              <!-- Filtros WEB -->
              <div class="showWeb">
                <v-sheet
                  class="mb-3 mt-1"
                  :style="{ background: 'none' }"
                >
                  <div
                    class="myRequestScroll container__chip">
                    <span
                      v-for="(filterItem, i) of myRequestsStatuses"
                      :key="i"
                      :class="[filterRequests.includes(filterItem.status)
                        ? 'chip__active'
                        : '',
                        'chip__agrupaciones chip__filter v-chip']"
                    >
                    <v-badge
                      class="d-inline"
                      inline
                      :color="stateColor(filterItem.status)"
                      dot
                    ></v-badge>
                      <span @click="selectFilterRequest(filterItem)">
                        {{ filterItem.text }}
                      </span>
                    </span>
                  </div>
                </v-sheet>
              </div>

              <!-- Filtros Movil -->
              <FiltersSlide
                v-if="showFilters && flags.secondBlock"
                :isBadge="isBadge"
                :filters="filtersInitialRequests"
                :selectedFilters="filterRequests"
                @filter-selected="selectFilterRequest"
              />
            </v-row>
          </template>

          <!-- Listado -->
          <template v-slot:item-0="data">
            <v-avatar
              :color="stateColor(data.column.value)"
              :size="24"
            >
              <span class="white--text text-caption">
                {{ data.column.initials }}
              </span>
            </v-avatar>
          </template>
        </search-box>
      </v-col>
    </v-row>

    <v-row :id="!$vuetify.breakpoint.smAndDown ? 'necesitasAlgoNoFunciona' : ''">
      <v-col cols="12" sm="6">
        <v-card v-if="$vuetify.breakpoint.smAndDown"
          class="gradient-button white--text py-4"
          to="/request"
          id="necesitasAlgo"
        >
          <v-card-title class="text-body-1">
            <span>
              <v-icon
                large
                class="mr-2 white--text"
              >mdi-gesture-tap-button</v-icon>
              {{ $t('views.home.requests.title') }}
            </span>
          </v-card-title>
        </v-card>
        <!-- eslint-disable max-len -->
        <search-box
          v-else
          :id="!$vuetify.breakpoint.smAndDown ? 'necesitasAlgo' : ''"
          class="home-request-searchbox"
          :title="$t('views.home.requests.title')"
          :items="requestsForms.data.map((req) => [ req.icon, req.name, req.tooltip ])"
          :loaderRows="4"
          :loading="requestsForms.loading"
          :overflow="flags.requestsFormsBookmarks"
          :isFormGeneric="flags.isFormGeneric"
          @click:viewMore="$router.push({
            path: '/request',
            query: {
              search: (requestsForms.vModel || '').trim(),
              bookmarks: flags.requestsFormsBookmarks }
          })"
          @click:item="({ index }) => {
            const item = requestsForms.data[index];
            const prefix = (item.family || {}).id === $getConst('categoryFamily') ? '/request/' : '/element/r/';
            if(item.hostName && /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\\/]))?/.test(item.hostName)){
              urlHostName(item.hostName)
            } else {
              $router.push(`${prefix}${item.id}`);
            }
          }"
        >
          <!-- <template v-slot:badge v-if="false"> -->
          <template v-slot:badge v-if="!this.user.hasIosUser()">
            <v-tooltip
              transition="fade-transition"
              bottom
              open-delay="500"
              :disabled="flags.requestsFormsBookmarks && requestsForms.loading"
            >
              <template v-slot:activator="{ on }">
              <v-btn
                icon
                color="primary"
                @click="() => handleBookmarks('requestsForms', BOOKMARK_TYPES.REQUESTS)()"
                :disabled="requestsForms.loading"
                :loading="flags.requestsFormsBookmarks && requestsForms.loading"
                v-on="on"
              >
                <v-icon>{{
                    flags.requestsFormsBookmarks ? 'mdi-bookmark' : 'mdi-bookmark-outline'
                }}</v-icon>
              </v-btn>
              </template>
              <span>{{
                $t(`views.home.requests.favs.${ flags.requestsFormsBookmarks ? 'hide' : 'show' }`)
              }}</span>
            </v-tooltip>
          </template>
        </search-box>
      </v-col>

      <v-col cols="12" sm="6">
        <v-card v-if="$vuetify.breakpoint.smAndDown"
          class="gradient-button white--text py-4"
          to="/incident"
          id="algoNoFunciona"
        >
          <v-card-title class="text-body-1">
            <span>
              <v-icon
                large
                class="mr-2 white--text"
              >mdi-cog-off-outline</v-icon>
              {{ $t('views.home.incidents.title') }}
            </span>
          </v-card-title>
        </v-card>

        <search-box
          v-else
          id="algoNoFunciona"
          class="home-request-searchbox"
          :title="$t('views.home.incidents.title')"
          :items="incidentsForms.data.map((req) => [ req.icon, req.name, req.tooltip ])"
          :loading="incidentsForms.loading"
          :loaderRows="4"
          :overflow="flags.incidentsFormsBookmarks"
          @click:viewMore="$router.push({
            path: '/incident',
            query: {
              search: (incidentsForms.vModel || '').trim(),
              bookmarks: flags.incidentsFormsBookmarks,
            }
          })"
          @click:item="({ index }) => $router.push(`/element/i/${incidentsForms.data[index].id}`)"
        >
          <!-- <template v-slot:badge v-if="false"> -->
          <template v-slot:badge v-if="!this.user.hasIosUser()">
            <v-tooltip
              transition="fade-transition"
              bottom
              open-delay="500"
              :disabled="flags.incidentsFormsBookmarks && incidentsForms.loading"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  color="primary"
                  @click="() => handleBookmarks('incidentsForms', BOOKMARK_TYPES.INCIDENTS)()"
                  :disabled="incidentsForms.loading"
                  :loading="flags.incidentsFormsBookmarks && incidentsForms.loading"
                  v-on="on"
                >
                  <v-icon>{{
                      flags.incidentsFormsBookmarks ? 'mdi-bookmark' : 'mdi-bookmark-outline'
                  }}</v-icon>
                </v-btn>
              </template>
              <span>{{
                $t(`views.home.incidents.favs.${ flags.incidentsFormsBookmarks ? 'hide' : 'show' }`)
              }}</span>
            </v-tooltip>
          </template>
        </search-box>
      </v-col>
    </v-row>
    <!-- TOUR WEB -->
    <template v-if="showTourHome && !isMobileTour">
      <TourHome
        v-for="index in tourHomeIndexes"
        :key="index"
        :value="isTourStepVisible(index)"
        :steps="getTourStep(index)"
        :stepIndex="index"
        :totalTourSteps="(tourHomeSteps || []).length"
        :cardWidth="440"
        :offsetY="10"
        @input="handleTourVisibilityChange"
        @finished="handleTourFinished"
      />
    </template>
    <!-- TOUR MOBILE -->
    <template v-if="showTourHome && isMobileTour">
      <TourHomeMobile
        v-for="index in tourHomeIndexes"
        :key="index"
        :value="isTourStepVisible(index)"
        :steps="getTourStep(index)"
        :stepIndex="index"
        :totalTourSteps="(tourHomeSteps || []).length"
        @input="handleTourVisibilityChange"
        @finished="handleTourFinished"
      />
    </template>

  </div>
</template>

<script>
import moment from 'moment';
import { mapState, mapGetters } from 'vuex';
import { io } from 'socket.io-client';
import { BOOKMARK_TYPES, STATUS as BOOKMARKS_STATUS } from '@/store/modules/bookmarks';
import { TYPE as CATEGORIES_TYPES } from '@/store/modules/catalog';
import {
  SearchBox,
  SearchGeneral,
  CarouselMarquee,
  FiltersSlide,
} from '@/components'; // ms
import TourHome from '@/components/TourHome.vue';
import TourHomeMobile from '@/components/TourHomeMobile.vue';
import { NAMED_ROLES } from '@/store/modules/session';

async function managedSearchboxUpdating(ns, filters, dataFormatFn) {
  const { client } = this;
  if (this[ns] == null) {
    throw new Error(`there's no data named ${ns}`);
  }
  const dataBlock = this[ns];
  if (dataBlock.req != null) {
    dataBlock.req.cancel();
  }
  dataBlock.loading = true;
  let response;
  try {
    dataBlock.req = client[ns](filters);
    const rawResponse = await dataBlock.req;
    response = dataBlock.req.format(rawResponse);
    dataBlock.req = null;
    dataBlock.data = typeof dataFormatFn === 'function' ? dataFormatFn(response.list) : response.list;
    dataBlock.total = response.total;
    dataBlock.loading = false;
  } catch (ex) {
    // eslint-disable-next-line no-underscore-dangle
    if (ex.__CANCEL__ !== true) {
      console.error(`error updating searchbox ${ns}`, ex);
      dataBlock.data = [];
      dataBlock.total = 0;
      dataBlock.req = null;
      dataBlock.loading = false;
    }
  }
  return response;
}

const REQUESTS_SELECT_FILTERS_DEBOUNCE_TIME = 700; // ms
const REQUESTS_TEXT_FILTERS_DEBOUNCE_TIME = 1000;
const TOTAL_SEARCH = 1;
const TYPE_REQUEST = 'r';

export default {
  components: {
    CarouselMarquee,
    SearchBox,
    SearchGeneral,
    FiltersSlide,
    TourHome,
    TourHomeMobile,
  },
  data: () => ({
    updateBoxThrottle: null,
    lastAccess: null,
    flags: {
      firstBlock: false,
      secondBlock: false,
      requestsFormsBookmarks: false,
      incidentsFormsBookmarks: false,
      isFormGeneric: false,
    },
    ...['userPendingRequests', 'myRequests', 'requestsForms', 'incidentsForms']
      .reduce((acum, curr) => {
        // eslint-disable-next-line no-param-reassign
        acum[curr] = {
          loading: false,
          total: 0,
          data: [],
          req: null,
          vModel: null,
          firstResult: null,
        };
        return acum;
      }, {}),
    statesFilter: ['Pte aprobar', 'Confirmar cierre'],
    listSearchCatalog: null,
    countSearchCatalog: 0,
    contrasenaCaduca: false,
    showFilters: false,
    mobileUser: '',
    isDataUser: false,
    diasParaCaducidasContrasena: 0,
    announcements: [],
    applicationsStatus: null,
    filterPendings: ['FIX', 'PEND_APRO', 'DEL'],
    filterRequests: ['OP', 'PL_ENT', 'FIX', 'PEND_APRO', 'DEL', 'PEND_PRES'],
    filterInitialPendings: [],
    filtersInitialRequests: [],
    isBadge: true,
    tour: 0,
    advanceTourOnClose: false,
    showTourHome: false,
    tourHomeSteps: null,
    isMobileTour: false,
  }),

  methods: {
    getStoredTourIndex() {
      const storedIndex = parseInt(localStorage.getItem('tourStepsIndex') || '0', 10);
      console.log('getStoredTourIndex', { storedIndex });
      return Number.isNaN(storedIndex) ? 0 : storedIndex;
    },
    getTourStep(index) {
      const step = (this.tourHomeSteps || [])[index];
      // console.log('getTourStep', { index, step });
      return step ? [step] : [];
    },
    isTourStepVisible(index) {
      // console.log('isTourStepVisible',
      //   {
      //     index,
      //     tour: this.tour,
      //     showTourHome: this.showTourHome,
      //     stepsLength: this.getTourStep(index).length,
      //   });
      return this.showTourHome && this.tour === index && this.getTourStep(index).length > 0;
    },
    handleTourFinished() {
      this.advanceTourOnClose = true;
    },
    handleTourVisibilityChange(value) {
      if (value) {
        this.showTourHome = true;
        return;
      }

      if (!this.advanceTourOnClose) {
        this.showTourHome = false;
        return;
      }

      this.advanceTourOnClose = false;
      this.tour = this.getStoredTourIndex();
      this.showTourHome = this.getTourStep(this.tour).length > 0;
    },
    selectFilterPending(data) {
      const { status } = data;
      if (this.filterPendings.includes(status)) {
        if (this.filterPendings.length === 1) {
          // TODO atLeastOneFilter
          console.log('components.searchBox.atLeastOneFilter');
          // this.$store.dispatch('messages/createNotificationMessage', {
          //   type: 'warning',
          //   icon: 'mdi-alert',
          //   title: this.$t('components.searchBox.atLeastOneFilter'),
          //   timeout: this.$getConst('notifications.timeout'),
          // });
          return;
        }
        this.filterPendings.splice(this.filterPendings.indexOf(status), 1);
      } else {
        this.filterPendings.push(status);
      }
      this.updateUserPendingRequests(this.filterPendings);
    },
    selectFilterRequest(data) {
      const { status } = data;
      if (this.filterRequests.includes(status)) {
        if (this.filterRequests.length === 1) {
          // TODO atLeastOneFilter
          console.log('components.searchBox.atLeastOneFilter');
          // this.$store.dispatch('messages/createNotificationMessage', {
          //   type: 'warning',
          //   icon: 'mdi-alert',
          //   title: this.$t('components.searchBox.atLeastOneFilter'),
          //   timeout: this.$getConst('notifications.timeout'),
          // });
          return;
        }
        this.filterRequests.splice(this.filterRequests.indexOf(status), 1);
      } else {
        this.filterRequests.push(status);
      }
      this.updateMyRequests(this.filterRequests);
    },
    wordInitials(word) {
      return word.split(' ')
        .map((part) => part.trim().charAt(0).toUpperCase())
        .join('');
    },
    async retrieveLastAccess() {
      const client = this.$api.getClient('registerSession');
      const lastAccess = await client.lastAccess();
      return lastAccess;
    },
    viewMoreByStatuses(baseURL, statuses) {
      this.$router.push(`${baseURL}?${statuses.map((s) => `status=${s}`).join('&')}`);
    },
    viewItem(baseURL, itemId) {
      this.$router.push(`${baseURL}/${itemId}?back=/`);
    },
    initializeRequestCategoriesBlock(val) {
      if (val != null) {
        const values = Object.values(val);
        if (values.length > 0) {
          // initialize request forms searchbox
          const datablock = this.requestsForms;
          datablock.total = values.length;
          datablock.data = values.concat([])
            .map((v) => v.model)
            .splice(0, 4);
          datablock.loading = false;
        }
      }
    },
    initializeIncidentCategoryBlock(values) {
      if (values.length > 0) {
        // initialize request forms searchbox
        const datablock = this.incidentsForms;
        datablock.total = values.length;
        datablock.data = values.concat([])
          .splice(0, 4);
        datablock.loading = false;
      }
    },
    isCitizen() {
      return this.user.hasIosUser();
    },
    /*
     * this method handles requests form search box data.
     * Both search data and fav bookmarks are alternated
     * considering cache and performance
     */
    handleBookmarks(searchboxNS, bookmarkType) {
      const bookmarksStoreState = this.$store.state.bookmarks[bookmarkType];
      const flagName = `${searchboxNS}Bookmarks`;
      return async () => {
        const searchboxSection = this[searchboxNS];
        this.flags[flagName] = !this.flags[flagName];
        if (this.flags[flagName]) {
          // check if bookmarks store has been loaded
          if (bookmarksStoreState.status !== BOOKMARKS_STATUS.SUCCESS) {
            searchboxSection.loading = true;
            try {
              await this.$store.dispatch('bookmarks/get', { type: bookmarkType });
            } catch (ex) {
              console.error('error getting request bookmarks', ex);
            }
            searchboxSection.loading = false;
          }
          searchboxSection.lastSearchData = [].concat(searchboxSection.data); // copy
          searchboxSection.data = (bookmarksStoreState.bookmark || {}).items || [];
        } else {
          searchboxSection.data = searchboxSection.lastSearchData || [];
          searchboxSection.lastSearchData = null;
        }
      };
    },
    urlHostName(url) {
      if (url !== null && /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\\/]))?/.test(url)) {
        window.location.href = url;
      }
      return null;
    },
    openFormGeneric() {
      this.$router.push({
        name: 'formGeneric',
        path: `/element/r/${ process.env.VUE_APP_GENERAL_FORM }`,
        params: {
          isPermision: true,
          element: process.env.VUE_APP_GENERAL_FORM,
          type: TYPE_REQUEST,
        },
      });
    },
    async updatePass() {
      const { id, userid, dni } = this.$store.getters['session/user'];
      const dataReq = {
        apiCges: {
          delegado: userid,
          uuidSuscriptor: id,
        },
        dni,
      };

      const messageId = await this.$store.dispatch('messages/createNotificationMessage', {
        icon: 'progress-circular',
        title: this.$t('views.home.pass.send'),
      });

      try {
        const response = await this.agesconClient.updatePass(dataReq);
        this.$store.dispatch('messages/updateMessage', {
          id: messageId,
          type: 'success',
          icon: 'mdi-check-circle',
          title: this.$t('views.home.pass.ok'),
          timeout: this.$getConst('notifications.timeout'),
        });
        const { data } = response;
        const dataUser = data?.collection_cnt?.cnt[0];
        if (dataUser) {
          this.mobileUser = dataUser.destination;
          this.contrasenaCaduca = false;
          this.isDataUser = true;
        }
      } catch (err) {
        this.$store.dispatch('messages/updateMessage', {
          id: messageId,
          type: 'error',
          icon: 'mdi-close-circle',
          title: this.$t('views.home.pass.ko'),
          timeout: this.$getConst('notifications.timeout'),
        });
        console.error('error update pass', err);
        throw err;
      }
    },
    async getApplicationsStatus() {
      try {
        const { id, userid } = this.$store.getters['session/user'];
        this.applicationsStatus = await this.applicationsClient.getApplicationsStatus({
          apiCges: {
            delegado: userid,
            uuidSuscriptor: id,
            endpoint: 'cges/notif/gestnotif/applicationsstatus',
          },
        });
      } catch (error) {
        console.log(error);
      }
    },
    maybeGoToSearch(e) {
      this.$root.$emit('search-global-home', e);
    },
    createWebsocket() {
      const URL = window.location.host;
      let path = '';
      if (URL === 'mics.sas.junta-andalucia.es') {
        path = '';
      } else if (URL === 'www.sspa.juntadeandalucia.es') {
        path = '/servicioandaluzdesalud/mics';
      } else if (URL === 'ws001.sspa.juntadeandalucia.es') {
        path = '/mics';
      }

      const socket = io(URL, {
        path: `${path}/socket.io`,
      });

      socket.on('newAnnouncements', (announcements) => {
        this.$store.dispatch('announcements/add', { listAnnouncements: announcements });
        this.announcements = this.$store.getters['announcements/list'];
      });

      socket.emit('connection Login', null);
    },

    async modifPass() {
      const messageId = await this.$store.dispatch(
        'messages/createNotificationMessage',
        {
          icon: 'progress-circular',
          title: 'Enviando SMS de cambio de contraseña.',
        },
      );
      const { userid } = this.user;
      if (userid) {
        try {
          const response = await this.$api
            .getClient('user')
            .requestUser(userid);

          const { data } = response;
          if (data && data.code) {
            let msgNotifError;
            if (this.$te(`views.agescon.errors.${data.code}`)) {
              msgNotifError = this.$t(`views.agescon.errors.${data.code}`);
            } else {
              msgNotifError = this.$t('views.agescon.errors.default');
            }
            this.$store.dispatch('messages/updateMessage', {
              id: messageId,
              title: msgNotifError,
              type: 'error',
              dismissible: true,
              timeout: this.$getConst('notifications.timeoutPlus'),
            });
          } else {
            const { collection_cnt: collectionCnt } = data;
            const user = collectionCnt.cnt[0];
            const msgNotif = this.$t(`views.agescon.finishType.${user.type}`, { destination: user.destination });

            this.$store.dispatch('messages/updateMessage', {
              id: messageId,
              title: msgNotif,
              icon: 'mdi-check',
              type: 'success',
              dismissible: true,
              timeout: this.$getConst('notifications.timeoutPlus'),
            });
          }
        } catch (error) {
          const msgNotif = this.$t('views.agescon.errors.default');
          this.$store.dispatch('messages/updateMessage', {
            id: messageId,
            title: msgNotif,
            type: 'error',
            dismissible: true,
            timeout: this.$getConst('notifications.timeoutPlus'),
          });
        }
      } else {
        const msgNotif = this.$t('views.agescon.errors.default');
        this.$store.dispatch('messages/updateMessage', {
          id: messageId,
          title: msgNotif,
          type: 'error',
          dismissible: true,
          timeout: this.$getConst('notifications.timeoutPlus'),
        });
      }
    },
    goToProfile() {
      this.$router.push('/profile/edit');
    },
    async getTour(appPromo) {
      const primaryIndexEnv = process.env.VUE_APP_KI_POPUP_LOGIN_TOUR_INDEX;
      console.log('process:', { process, e: process.env });
      const id = process.env.VUE_APP_KI_POPUP_LOGIN_TOUR;
      const filters = {
        status: '(70, 80)',
        primaryIndex: parseInt(primaryIndexEnv, 10),
        id: parseInt(id, 10),
      };
      try {
        console.log('getTour HOME:', filters);
        const response = await appPromo.getTour(filters);
        // const index = 0;
        console.log('response getTour HOME:', response);
        return response;
      } catch (error) {
        console.log(error);
        return error;
      }
    },
  },
  watch: {
    '$vuetify.breakpoint.smAndUp': {
      deep: true,
      handler(val) {
        this.flags.firstBlock = val;
      },
    },
    catalog(val) {
      if (val != null && val.id != null) {
        // initialize incident forms searchbox
        this.updateIncidentsForms('', true);
      }
    },
    requestCategories(val) {
      if (this.isCitizen()) {
        this.updateRequestsForms('', true);
      } else {
        this.initializeRequestCategoriesBlock(val);
      }
    },
  },

  async created() {
    this.agesconClient = this.$api.getClient('agescon');
    this.applicationsClient = this.$api.getClient('applications');
    const appPromo = this.$api.getClient('appPromo');
    this.getApplicationsStatus();
    // Borramos los datos del tour si existen
    localStorage.removeItem('tourSteps');
    localStorage.removeItem('tourStepsIndex');
    // $vuetify.breakpoint.mobile
    // const userAgent = navigator.userAgent || navigator.vendor || '';
    // const isMobileBrowser =
    // /android|iphone|ipad|ipod|iemobile|opera mini|mobile/i.test(userAgent);
    // this.isMobileTour = isMobileBrowser;
    this.isMobileTour = false;
    this.showTourHome = JSON.parse(localStorage.getItem('showTourHome')) || false;
    if (this.showTourHome) {
      const response = await this.getTour(appPromo);
      if (response) {
        const storedTourSteps = localStorage.getItem('tourSteps')
          ? JSON.parse(localStorage.getItem('tourSteps'))
          : [];

        this.tourHomeSteps = storedTourSteps.filter((step) => (
          this.isMobileTour ? step.app === true : step.web === true
        ));
        console.log('tourHomeSteps', { t: this.tourHomeSteps, l: localStorage.getItem('tourHomeSteps') });
        this.tour = this.getStoredTourIndex();
        console.log('initial showTourHome', { s: localStorage.getItem('showTourHome'), p: this.showTourHome });
      }
    }

    const fechaHoy = new Date();
    if (this.user && this.user.fechaPassCaduca) {
      const fechaCaducidadContrasena = new Date(this.user.fechaPassCaduca);
      const diferenciaEnMilisegundos = fechaCaducidadContrasena - fechaHoy;
      const milisegundosPorDia = 1000 * 60 * 60 * 24;
      const diasMinimoAlertaCaducidadContrasena = this.$getConst('home.caducidadContrasena');

      // se inactivan los token de la app
      if (diferenciaEnMilisegundos <= 0) {
        await this.$api.getClient('userInfo').inactiveAppToken(this.user.id);
      }

      this.diasParaCaducidasContrasena = Math.floor(diferenciaEnMilisegundos / milisegundosPorDia);
      if (
        this.diasParaCaducidasContrasena >= 0
        && this.diasParaCaducidasContrasena < diasMinimoAlertaCaducidadContrasena) {
        this.contrasenaCaduca = true;
      }
    }

    if (this.catalog == null) {
      this.$store.dispatch('catalog/loadCatalogCategories', {
        userId: this.user.id,
        locationId: this.user.location.id,
        type: CATEGORIES_TYPES.REQUEST,
      });
      this.requestsForms.loading = true;
    }

    this.client = this.$api.getClient('dashboard');

    this.updateUserPendingRequests = this.$debounce((value) => {
      managedSearchboxUpdating.call(this, 'userPendingRequests', value, (pendingRequests) => pendingRequests);
    }, REQUESTS_SELECT_FILTERS_DEBOUNCE_TIME);

    this.updateMyRequests = this.$debounce((value) => {
      managedSearchboxUpdating.call(this, 'myRequests', value, (myRequests) => myRequests);
    }, REQUESTS_SELECT_FILTERS_DEBOUNCE_TIME);

    this.updateRequestsForms = this.$debounce(async (value) => {
      if (value.trim() === '' && this.updateRequestsForms.firstResult != null) {
        const result = this.updateRequestsForms.firstResult;
        this.updateRequestsForms.total = result.total;
        this.updateRequestsForms.data = result.list;
      } else {
        try {
          const result = await managedSearchboxUpdating.call(this, 'requestsForms',
            value, (requestsForms) => requestsForms);
          if (value === '') {
            this.requestsForms.firstResult = result;
          }
          this.listSearchCatalog = (result || {}).list || [];
          if (this.listSearchCatalog.length === 0) {
            this.countSearchCatalog += 1;
          } else {
            this.countSearchCatalog = 0;
          }
          if (this.countSearchCatalog >= TOTAL_SEARCH) {
            this.flags.isFormGeneric = true;
            this.countSearchCatalog = 0;
          }
        } catch (ex) {
          console.error('error querying incidents');
        }
      }
    }, REQUESTS_TEXT_FILTERS_DEBOUNCE_TIME);

    this.updateIncidentsForms = this.$debounce(async (value) => {
      if (value.trim() === '' && this.incidentsForms.firstResult != null) {
        const result = this.incidentsForms.firstResult;
        this.incidentsForms.total = result.total;
        this.incidentsForms.data = result.list;
      } else {
        try {
          const result = await managedSearchboxUpdating.call(this, 'incidentsForms',
            value, (incidentsForms) => incidentsForms);
          if (value === '') {
            this.incidentsForms.firstResult = result;
          }
        } catch (ex) {
          console.error('error querying incidents');
        }
      }
    }, REQUESTS_TEXT_FILTERS_DEBOUNCE_TIME);

    this.$root.$on('openFormGeneric', () => {
      this.openFormGeneric();
    });

    const isWebSocket = this.$store.getters['announcements/create'];
    if (!isWebSocket) {
      this.createWebsocket();
    } else {
      this.announcements = this.$store.getters['announcements/list'];
    }
    console.log('created showTourHome', { s: localStorage.getItem('showTourHome'), p: this.showTourHome });
    localStorage.removeItem('suscriptorsList');
  },

  async mounted() {
    // initialize pending requests searchbox
    this.userPendingRequests.vModel = this.$getConst('dashboard.pendingRequestsInitialFilters');
    this.updateUserPendingRequests(this.userPendingRequests.vModel);
    // initialize user requests searchbox
    this.myRequests.vModel = this.user.isUserTecnical
      ? this.$getConst('dashboard.myRequestsTICInitialFilters')
      : this.$getConst('dashboard.myRequestsInitialFilters');
    this.updateMyRequests(this.myRequests.vModel);
    this.announcements = this.$store.getters['announcements/list'];

    if (this.requestCategories != null
    && (!this.isCitizen())) {
      // initialize request forms searchbox
      this.initializeRequestCategoriesBlock(this.requestCategories);
    } else {
      this.updateRequestsForms('', true);
    }

    if (this.catalog != null) {
      let firstElements = null;
      if (this.incidentCategories != null) {
        const [incidentCategory] = Object.keys(this.incidentCategories);
        firstElements = (this.incidentCategories[incidentCategory] || {}).elements;
      }
      if (firstElements != null) {
        this.initializeIncidentCategoryBlock(firstElements);
      } else {
        // initialize incident forms searchbox
        this.updateIncidentsForms('', true);
      }
    }

    this.lastAccess = this.$store.getters['session/lastAccess'];
    console.log('lastAccess', this.lastAccess);
    this.filterInitialPendings = this.$getConst('initialFilters.pending');
    this.filtersInitialRequests = this.user.isUserTecnical
      ? this.$getConst('initialFilters.requestTic')
      : this.$getConst('initialFilters.requestNoTic');

    const { pathError } = this.$route.query || {};
    if (pathError) {
      await this.$store.dispatch(
        'messages/createNotificationMessage',
        {
          title: 'El enlace al que intentas acceder no es válido',
          type: 'error',
          dismissible: true,
          timeout: this.$getConst('notifications.timeoutPlus'),
        },
      );

      const newQuery = { ...(this.$route.query || {}) };
      delete newQuery.pathError;
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: newQuery,
      });
    }

    setInterval(() => {
      this.showFilters = true;
    }, 1000);
  },

  computed: {
    previousRoute() {
      console.log('this route ====', this.$route);
      return this.$route.matched[this.$route.matched.length - 2].path || null;
    },
    ...mapState({
      catalog: ({ catalog: { catalog } }) => catalog,
      requestCategories: ({ catalog: { categories } }) => categories[CATEGORIES_TYPES.REQUEST],
      incidentCategories: ({ catalog: { categories } }) => categories[CATEGORIES_TYPES.INCIDENT],
    }),
    ...mapGetters({
      user: 'session/user',
      hasRoles: 'session/hasRole',
    }),
    userPendingRequestsStatuses() {
      if (this?.applicationsStatus?.data !== undefined) {
        return this.$getConst('dashboard.pendingRequestsSupportedFilters').map((status) => {
          const text = this.applicationsStatus?.data?.find(
            (i) => i.cr_stat_code === status,
          ).cr_stat_zdescripcion_web;
          return {
            text,
            status,
            value: status,
            initials: this.wordInitials(text),
          };
        });
      }
      return null;
    },
    myRequestsStatuses() {
      if (this?.applicationsStatus?.data !== undefined) {
        const supportedFilters = this.user.isUserTecnical
          ? this.$getConst('dashboard.myRequestsTICSupportedFilters')
          : this.$getConst('dashboard.myRequestsSupportedFilters');
        return supportedFilters
          .map((status) => {
            const text = this.applicationsStatus?.data?.find(
              (i) => i.cr_stat_code === status,
            ).cr_stat_zdescripcion_web;
            return ({
              text,
              status,
              value: status,
              initials: this.wordInitials(text),
            });
          });
      }
      return null;
    },
    states() {
      return this.myRequestsStatuses.map((row) => row.value)
        .filter((state, idx, list) => list.indexOf(state) === idx);
    },
    colors() {
      return this.$getConst('dashboard.filtersColors');
    },
    stateColor() {
      return (state) => this.colors[state] || '#bbb';
    },
    tourHomeIndexes() {
      return (this.tourHomeSteps || []).map((_, index) => index);
    },
    lastAccessDate() {
      const date = this.lastAccess != null ? moment(this.lastAccess) : null;
      return date != null ? date.format('DD/MM/YYYY') : null;
    },
    lastAccessTime() {
      const date = this.lastAccess != null ? moment(this.lastAccess) : null;
      return date != null ? date.format('HH:mm') : null;
    },
    BOOKMARK_TYPES: () => BOOKMARK_TYPES,

    NAMED_ROLES: () => NAMED_ROLES,
  },
};
</script>

<style>
  .home-request-searchbox table td:first-child {
    width: 0; /* force first column to have minimum width as possible */
  }
  .w--100 {
    width: 100% !important;
  }
  .searchbar {
    min-width: 20rem;
    width: 33.3333%;
    margin-right: 3rem;
  }
  .container__btnSearch {
    display: flex;
    justify-content: center;
    margin: 1rem 0;
  }
  .container__btnSearch > div {
    margin: 0;
    background-color: #ffffff;
    padding: 0.3rem 1rem;
    border-radius: 50px;
    box-shadow: 0 1px 6px 0 #20212447;
  }
  .container__btnSearch .v-input__slot::after,
  .container__btnSearch .v-input__slot::before {
    border: none !important;
  }
  .container__btnSearch input {
    background-color: #ffffff;
  }
  .container__chip{
    padding: 0 16px;
  }
  .chip__active {
    background-color: #e6f1ee !important;
    border: 1px solid #27846d !important;
  }
  .chip__filter {
    margin: 0.3rem;
    cursor: pointer;
    background: #e0e0e0;
    border-radius: 16px;
    font-size: 14px;
    height: 32px;
    border-color: rgba(0, 0, 0, 0.12);
    color: rgba(0, 0, 0, 0.87);
    padding: 0 16px;
  }
  .containerMyRequest{
    width: 100% !important;
  }
  .showMobile {
    display: none !important;
  }

  .showMobile .v-slide-group__next,
  .showMobile .v-slide-group__prev {
    min-width: initial !important;
    flex: 0 1 30px !important;
  }

  .showMobile .v-slide-group__next,
  .showMobile .v-slide-group__prev {
    min-width: initial !important;
    flex: 0 1 30px !important;
  }

  .mdi-exclamation {
    font-size: x-large !important;
  }
  .v-alert--prominent .v-alert__icon {
    height: auto !important;
    min-width: auto !important;
  }
  @media screen and (max-width: 600px) {
    .showWeb {
      display: none !important;
    }

    .showMobile {
      display: flex !important;
    }

    .myRequestScroll{
      overflow: hidden;
      white-space: nowrap;
      overflow-x: auto;
      padding-bottom: 4px;
    }
}
</style>
